import { Link, Route } from 'react-router-dom';
import RelativeLinkFactory from 'web-react-ui/src/reactRouter/RelativeLinkFactory';

export default RelativeLinkFactory(Link, Route);
